import React, { useState, useEffect } from 'react';
import { getPagos } from '../services/api';

function Pagos() {
  const [pagos, setPagos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [buscar, setBuscar] = useState('');

  useEffect(() => {
    getPagos().then(res => { setPagos(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const filtrados = pagos.filter(p =>
    p.factura?.numero?.toLowerCase().includes(buscar.toLowerCase()) ||
    p.factura?.remNombre?.toLowerCase().includes(buscar.toLowerCase())
  );

  const fmt = (monto, moneda) => {
    if (moneda === 'DOP') return `RD$${Number(monto).toLocaleString('es-DO', { minimumFractionDigits: 2 })}`;
    return `$${Number(monto).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>Cargando...</div>;

  const totalUSD = pagos.filter(p => p.moneda === 'USD').reduce((s, p) => s + p.monto, 0);
  const totalDOP = pagos.filter(p => p.moneda === 'DOP').reduce((s, p) => s + p.monto, 0);

  return (
    <div>
      {/* Resumen */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16, marginBottom: 24 }}>
        <div style={{ background: 'white', borderRadius: 12, padding: 20, border: '1px solid #e2e8f0' }}>
          <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500, textTransform: 'uppercase' }}>Total Pagos</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#1e293b', margin: '6px 0' }}>{pagos.length}</div>
        </div>
        <div style={{ background: 'white', borderRadius: 12, padding: 20, border: '1px solid #e2e8f0' }}>
          <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500, textTransform: 'uppercase' }}>Total USD</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#16a34a', margin: '6px 0' }}>{fmt(totalUSD, 'USD')}</div>
        </div>
        <div style={{ background: 'white', borderRadius: 12, padding: 20, border: '1px solid #e2e8f0' }}>
          <div style={{ fontSize: 12, color: '#64748b', fontWeight: 500, textTransform: 'uppercase' }}>Total DOP</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#0d2461', margin: '6px 0' }}>{fmt(totalDOP, 'DOP')}</div>
        </div>
      </div>

      {/* Filtro */}
      <div style={{ marginBottom: 18 }}>
        <input placeholder="Buscar por factura o cliente..." value={buscar} onChange={e => setBuscar(e.target.value)}
          style={{ padding: '8px 12px', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 13, fontFamily: 'inherit', outline: 'none', width: 300 }} />
      </div>

      <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px', borderBottom: '1px solid #f1f5f9' }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Historial de Pagos</h3>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Fecha', 'Factura', 'Cliente', 'Monto', 'Moneda', 'Nota', 'Registrado por'].map(h => (
                  <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtrados.length === 0 ? (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>No hay pagos registrados</td></tr>
              ) : filtrados.map(p => (
                <tr key={p.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '13px 16px', fontSize: 13 }}>{new Date(p.fecha).toLocaleDateString('es-DO')}</td>
                  <td style={{ padding: '13px 16px', fontFamily: 'monospace', fontSize: 13, fontWeight: 600 }}>{p.factura?.numero}</td>
                  <td style={{ padding: '13px 16px', fontSize: 14 }}>{p.factura?.remNombre}</td>
                  <td style={{ padding: '13px 16px', fontSize: 14, fontWeight: 700, color: '#16a34a' }}>{fmt(p.monto, p.moneda)}</td>
                  <td style={{ padding: '13px 16px' }}>
                    <span style={{ background: p.moneda === 'USD' ? '#dbeafe' : '#dcfce7', color: p.moneda === 'USD' ? '#0d2461' : '#16a34a', padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 600 }}>{p.moneda}</span>
                  </td>
                  <td style={{ padding: '13px 16px', fontSize: 13, color: '#64748b' }}>{p.nota || '—'}</td>
                  <td style={{ padding: '13px 16px', fontSize: 13, color: '#64748b' }}>{p.usuario?.nombre}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Pagos;